(() => {
  const HANDLE = 'custom-nfc-business-cards';
  const onProduct = () => location.pathname.split('/').filter(Boolean).includes(HANDLE);
  const money = (value) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
    style: 'currency',
    currency: 'GBP'
  }).format(value);

  function start() {
    if (!onProduct()) return;

    const form = document.querySelector('form.product-form');
    if (!form || form.dataset.nfcPricingReady === 'true') return;
    form.dataset.nfcPricingReady = 'true';

    const panel = document.createElement('section');
    panel.className = 'nfc-pricing-panel';
    panel.setAttribute('aria-label', 'NFC business card volume pricing');
    panel.innerHTML = '<p class="nfc-pricing-panel__eyebrow">Custom NFC business cards</p><h2>One card. Every contact detail. No subscription.</h2><p>Minimum order 100 cards.</p><div class="nfc-pricing-grid"><div class="nfc-pricing-tier"><strong>100–250 cards</strong><span>£1.00 each</span></div><div class="nfc-pricing-tier nfc-pricing-tier--best"><strong>251+ cards</strong><span>£0.80 each</span></div></div><p class="nfc-free-delivery">FREE UK STANDARD DELIVERY · DISPATCH IN 5–7 WORKING DAYS AFTER ARTWORK APPROVAL</p>';
    form.insertBefore(panel, form.firstChild);

    let quantity = form.querySelector('input[name="quantity"]');
    if (!quantity) {
      quantity = document.createElement('input');
      quantity.name = 'quantity';
    }
    quantity.type = 'number';
    quantity.id = 'NfcCardQuantity';
    quantity.className = 'quantity-input nfc-card-quantity';
    quantity.min = '100';
    quantity.step = '1';
    quantity.inputMode = 'numeric';
    quantity.required = false;
    quantity.removeAttribute('required');
    if (!Number(quantity.value) || Number(quantity.value) < 100) quantity.value = '100';

    const oldNote = form.querySelector('.nfc-pack-note');
    const block = document.createElement('div');
    block.className = 'nfc-quantity-block';
    block.innerHTML = '<label for="NfcCardQuantity">Number of cards</label><div class="nfc-live-summary" aria-live="polite"></div>';
    const summary = block.querySelector('.nfc-live-summary');
    block.insertBefore(quantity, summary);

    if (oldNote) {
      oldNote.replaceWith(block);
    } else {
      const row = form.querySelector('.quantity-row');
      if (row) form.insertBefore(block, row);
      else form.append(block);
    }

    const render = () => {
      const qty = Math.max(100, Math.floor(Number(quantity.value) || 100));
      if (String(qty) !== quantity.value) quantity.value = String(qty);
      const unit = qty >= 251 ? 0.80 : 1;
      const total = qty * unit;
      const hint = qty >= 251
        ? 'Best price unlocked.'
        : `Add ${251 - qty} more card${251 - qty === 1 ? '' : 's'} to unlock £0.80 each.`;
      const shipping = 'Free UK standard delivery.';
      summary.innerHTML = `<strong>${qty} card${qty === 1 ? '' : 's'} · ${money(unit)} each · ${money(total)} estimated product total</strong><p class="nfc-tier-hint">${hint}</p><p>${shipping}</p>`;
    };

    quantity.addEventListener('input', render);
    quantity.addEventListener('change', () => {
      quantity.value = String(Math.max(100, Math.floor(Number(quantity.value) || 100)));
      render();
    });
    render();

    const file = form.querySelector('input[type="file"][name*="Logo or artwork"]');
    if (file) {
      const status = document.createElement('span');
      status.className = 'nfc-upload-status';
      status.setAttribute('aria-live', 'polite');
      status.textContent = 'No artwork file selected - optional';
      file.insertAdjacentElement('afterend', status);
      file.addEventListener('change', () => {
        status.textContent = file.files?.[0] ? `Selected: ${file.files[0].name}` : 'No artwork file selected - optional';
      });
    }

    const shippingInfo = document.querySelector('.compact-product-info__item--shipping');
    if (shippingInfo) {
      const heading = shippingInfo.querySelector('strong');
      const detail = shippingInfo.querySelector('span');
      if (heading) heading.textContent = 'FREE UK DELIVERY';
      if (detail) detail.textContent = 'Standard delivery included';
    }

    document.querySelectorAll('.product-mobile-header h1, .product-details > h1').forEach((heading) => {
      heading.textContent = 'One card. Every contact detail. No subscription.';
    });

    const description = document.querySelector('.product-description-panel');
    if (description) {
      const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        node.nodeValue = node.nodeValue
          .replace(/upload your artwork and tell us where the NFC tap should open/gi, 'add any artwork and NFC details you already have')
          .replace(/Complete the artwork, contact and NFC-link form and upload your logo\./gi, 'Add any artwork, contact details and NFC link you already have, or leave them blank for us to confirm with you.');
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();